import { ADP_APIS } from "../../components/constants/app.constant";
import { getResource, patchResource, putResource } from "../axiosService";

export function updateEmployee(data: any) {
    const apiUrl = ADP_APIS.EMPLOYEE;
    return patchResource(apiUrl, data);
}

export const getAdpEmployee = () => {
    const apiUrl = ADP_APIS.EMPLOYEE;
    return getResource(apiUrl);
};
